import { ITopBarState } from '../../topBar/types';
import { ITopBarBoardState } from '../types';

export const TOP_BAR_BOARD_LOCALSTORAGE = 'TOP_BAR_BOARD_LOCALSTORAGE';

export interface ITopBarBoardStateLocalStorage extends ITopBarBoardState{
}
